<template>
    <div name="improvement-list" class="wrapper">
        <card4  />
        <card5 style="margin-top: 32px;"  />
        <card1 style="margin-top: 32px;" />
        <card2 style="margin-top: 32px;" />
        <card3 style="margin-top: 32px;" />
        <div class="end-contents" style="margin-top: 8px;">
            곧 오픈 예정이에요.
        </div>
    </div>
</template>

<script>
import Card1 from '@/components/molecules/m_uncomfortable/improvements/Card1'
import Card2 from '@/components/molecules/m_uncomfortable/improvements/Card2'
import Card3 from '@/components/molecules/m_uncomfortable/improvements/Card3'
import Card4 from '@/components/molecules/m_uncomfortable/improvements/Card4'
import Card5 from '@/components/molecules/m_uncomfortable/improvements/Card5'

export default {
    name: 'improvementList',
    components: {
        Card1,
        Card2,
        Card3,
        Card4,
        Card5
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 32px 0;
    }
    .end-contents {
        width: 100%;
        display: flex;
        height: 76px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        color: var(--gray-40-button-stroke, #D1D6DB);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 171.429% */
        border-radius: 18px;
        border: 1px solid var(--Gray-20, #F3F5F8);
        background: var(--gray-30-stroke, #E8EAEE);
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/m_uncomfortable/ImprovementList.vue